import {where as firestoreWhere} from 'firebase/firestore';

// A hardened `where()` — import this instead of firebase/firestore's
// (enforced by no-restricted-imports in eslint.config.mjs).
//
// `initializeFirestore` runs with `ignoreUndefinedProperties: true` (src/firebase.js)
// so writes can carry undefined fields. That setting also applies to QUERY values,
// and since firebase-js-sdk 12.x `parseQueryValue` no longer asserts that the parsed
// value is non-null. So `where(field, op, undefined)` silently builds a FieldFilter
// whose `value` is a raw `null` — note a real null parses to `{nullValue:'NULL_VALUE'}`,
// so a raw null is *always* this bug and never a legitimate filter.
//
// Nothing throws at the call site. It detonates later, asynchronously, when the query
// is canonified for the listen registry: `canonifyValue` does `'nullValue' in null`.
// That happens inside Firestore's AsyncQueue, which escalates it to an unrecoverable
// `INTERNAL ASSERTION FAILED (ID: b815)` panic — the Firestore client is dead for the
// rest of the session, so every live listener stops and every later unsubscribe()
// throws too (NORTHSHOREFD-6970A-1A..1D: one bad query, four Sentry issues, an app
// that can't load).
//
// Rejecting undefined here turns that into a synchronous throw at the call site that
// actually made the mistake, with an app stack Sentry can attribute. `null` is passed
// through untouched — it's a valid Firestore value.
export const where = (fieldPath, opStr, value) => {
    if (value === undefined) {
        const field = typeof fieldPath === 'string' ? fieldPath : String(fieldPath);
        throw new TypeError(
            `where('${field}', '${opStr}', undefined): a query value is undefined. `
            + 'Guard the value before building the query — Firestore accepts it silently '
            + '(ignoreUndefinedProperties) and then kills the client when the query runs.'
        );
    }

    return firestoreWhere(fieldPath, opStr, value);
};
